var _rect, _rect2, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextMergeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 4.75,
    width: 4.5,
    height: 4.5,
    rx: 1.25,
    stroke: "#272932",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 4.75,
    width: 4.5,
    height: 4.5,
    rx: 1.25,
    stroke: "#272932",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 14.75,
    width: 4.5,
    height: 4.5,
    rx: 1.25,
    stroke: "#272932",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 14.75,
    width: 4.5,
    height: 4.5,
    rx: 1.25,
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7C10.5 7 11.25 8 12 12C12.75 16 13.5 17 15 17",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7C13.5 7 12.375 9.5 12 12C11.5446 15.0358 10.5 17 9 17",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextMergeDark);
export default __webpack_public_path__ + "static/media/Text Merge Dark .dd73d95b401ff4892ae719ec329bf078.svg";
export { ForwardRef as ReactComponent };